import React, { useEffect, useState } from "react";
import { FaEye, FaPlus, FaSearch, FaTrashAlt } from "react-icons/fa";
import { FiEdit2, FiTrash2 } from "react-icons/fi";
import { MdEdit } from "react-icons/md";
import ConfirmDeleteModal from "../../Components/ConfirmDeleteModal/ConfirmDeleteModal";
import { FaTimes } from "react-icons/fa";
import AuthButton from "../../Components/AuthButton/AuthButton";
import PrimaryHeader from "../../Components/PrimaryHeader/PrimaryHeader";
import ParentComponent from "../../Components/ParentComponent/ParentComponent";
import { useSelector } from "react-redux";
import { addRoles, deleteRole, getRolebyid, getRoles, updateRole, ROLEIDDATA } from "../../Actions/actions";
import { useDispatch } from "react-redux";
import Loader from "../../Components/Loader/Loader";
import ClientDetails from "../ClientDetails/ClientDetails";
import Input from "../../Components/Input/Input";
import { toast } from "react-toastify";
import { subscriptionsCondition } from "../../Reducers/reducers";
import CustomToast from "../../Components/CustomToast/CustomToast";

const RoleManagementTable = () => {
  const { loginData, rolesData, loader, Privilages } = useSelector((state) => state.userReducer);
  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [deleteid, setdeleteid] = useState("");
  const [editid, setEditid] = useState("");
  const [isEdit, setisEdit] = useState(false);
  const [searchQuery, setSearchQuery] = useState("");

  const dispatch = useDispatch();
  const filteredRoles = rolesData?.filter((role) => {
    const lowerQuery = searchQuery.toLowerCase();
    return role.roleName?.toLowerCase().includes(lowerQuery) || role.description?.toLowerCase().includes(lowerQuery);
  });
  const getRolesdata = () => {
    dispatch(getRoles(loginData?.accessToken));
  };
  useEffect(() => {
    getRolesdata();
  }, []);
  const handleSearch = (e) => {
    setSearchQuery(e.target.value);
  };
  const confirmDelete = () => {
    dispatch(
      deleteRole(loginData?.accessToken, deleteid, () => {
        getRolesdata();
        setIsDeleteModalOpen(false);
      })
    );
  };

  const handleDelete = (id) => {
    setdeleteid(id);
    setIsDeleteModalOpen(true);
  };

  const handleEdit = (id) => {
    setisEdit(true);
    dispatch(getRolebyid(loginData?.accessToken, id));
    setIsModalOpen(true);
  };
  const PrivilagesArray = Privilages?.length > 0 ? Privilages.filter((item) => item.feature === "Role Management") : [];
  return (
    <ParentComponent>
      <PrimaryHeader
        PrivilagesCondition={
          PrivilagesArray?.length > 0 ? (PrivilagesArray[0].accessLevel == "Full Access" ? true : false) : true
        }
        buttonText="Add New Role"
        buttonIcon={<FaPlus className="mr-2" />}
        onButtonClick={() => {
          subscriptionsCondition(
            loginData?.clientData?.subscriptionType,
            () => {
              if (rolesData?.length >= 2) {
                toast.success(
                  <CustomToast type={"Warn"} message={"Only 2 roles allowed.Change Plan for creating more roles."} />,
                  {
                    position: "top-right",
                    autoClose: 3000,
                    hideProgressBar: true,
                    closeOnClick: true,
                    pauseOnHover: false,
                    draggable: false,
                    progress: undefined,
                    icon: false,
                    closeButton: false,
                  }
                );
              } else {
                dispatch({
                  type: ROLEIDDATA,
                  payload: {},
                });
                setisEdit(false);
                setIsModalOpen(true);
              }
            },
            () => {
              if (rolesData?.length >= 5) {
                toast.success(
                  <CustomToast type={"Warn"} message={"Only 5 roles allowed.Change Plan for creating more roles."} />,
                  {
                    position: "top-right",
                    autoClose: 3000,
                    hideProgressBar: true,
                    closeOnClick: true,
                    pauseOnHover: false,
                    draggable: false,
                    progress: undefined,
                    icon: false,
                    closeButton: false,
                  }
                );
              } else {
                dispatch({
                  type: ROLEIDDATA,
                  payload: {},
                });
                setisEdit(false);
                setIsModalOpen(true);
              }
            },
            () => {
              dispatch({
                type: ROLEIDDATA,
                payload: {},
              });
              setisEdit(false);
              setIsModalOpen(true);
            }
          );
        }}
      />

      {loader ? (
        <Loader />
      ) : (
        <>
          <div className="relative w-full  py-4 ">
            <FaSearch className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400" />
            <input
              type="text"
              placeholder="Search"
              value={searchQuery}
              onChange={handleSearch}
              className="border border-gray-300 rounded-lg pl-10 pr-4 py-2 w-full focus:outline-none focus:ring-2 focus:ring-[#361D32]"
            />
          </div>
          <div className="bg-white shadow-md rounded-lg overflow-hidden">
            <div className="overflow-x-auto">
              <table className="min-w-full">
                <thead className="bg-[#361D3214]">
                  <tr className="text-gray-500 text-sm">
                    <th className="py-4 px-4 text-left text-gray-600 font-semibold text-sm min-w-[150px]">Role Name</th>
                    {/* <th className="py-4 text-left text-gray-600 font-semibold text-sm min-w-[300px]">
                      Description
                    </th> */}
                    <th className="py-4 text-center text-gray-600 font-semibold text-sm min-w-[150px]">
                      Number of Users
                    </th>
                    <th className="py-4 text-center text-gray-600 font-semibold text-sm">Action</th>
                  </tr>
                </thead>
                <tbody>
                  {filteredRoles?.length > 0 ? (
                    filteredRoles.map((role) => (
                      <tr key={role.id} className="border-b last:border-none">
                        <td className="px-4 text-left text-gray-800">{role.roleName}</td>
                        {/* <td className="text-left text-gray-800">{role.description}</td> */}
                        <td className="px-4 text-center text-gray-800">{role.numberOfUsers}</td>
                        <td className="py-3 text-center flex space-x-2 justify-center ">
                          {role.roleName !== "Sales Executive" ? (
                            <>
                              {PrivilagesArray?.length > 0 ? (
                                PrivilagesArray[0].accessLevel !== "View Only" ? (
                                  <button
                                    className="text-gray-600 hover:text-blue-500 bg-gray-100 p-2 rounded-full"
                                    onClick={() => {
                                      setEditid(role.id);
                                      handleEdit(role.id);
                                    }}
                                  >
                                    <MdEdit />
                                  </button>
                                ) : (
                                  <div className="p-4"></div>
                                )
                              ) : (
                                <button
                                  className="text-gray-600 hover:text-blue-500 bg-gray-100 p-2 rounded-full"
                                  onClick={() => {
                                    setEditid(role.id);
                                    handleEdit(role.id);
                                  }}
                                >
                                  <MdEdit />
                                </button>
                              )}
                              {PrivilagesArray?.length > 0 ? (
                                PrivilagesArray[0].accessLevel == "Full Access" ? (
                                  <button
                                    className="text-gray-600 hover:text-red-500 bg-gray-100 p-2 rounded-full"
                                    onClick={() => handleDelete(role.id)}
                                  >
                                    <FaTrashAlt />
                                  </button>
                                ) : (
                                  <div className="p-4"></div>
                                )
                              ) : (
                                <button
                                  className="text-gray-600 hover:text-red-500 bg-gray-100 p-2 rounded-full"
                                  onClick={() => handleDelete(role.id)}
                                >
                                  <FaTrashAlt />
                                </button>
                              )}
                            </>
                          ) : (
                            <div className="p-4"></div>
                          )}
                        </td>
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td colSpan="4" className="text-center py-6 text-gray-500">
                        No roles found.
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
          </div>

          <ConfirmDeleteModal
            isOpen={isDeleteModalOpen}
            onClose={() => setIsDeleteModalOpen(false)}
            onConfirm={confirmDelete}
          />
          {isModalOpen && (
            <CreateNewRoleModal
              onClose={() => setIsModalOpen(false)}
              onHit={getRolesdata}
              edit={isEdit}
              roleid={editid ? editid : 0}
            />
          )}
        </>
      )}
    </ParentComponent>
  );
};

export default RoleManagementTable;

const CreateNewRoleModal = ({ onClose, onHit, edit, roleid }) => {
  const { loginData, roleIdData, rolesData } = useSelector((state) => state.userReducer);

  const privileges = [
    {
      id: 21,
      feature: "Dashboard",
      subFeature: null,
      accessLevel: "View Only",
    },
    {
      id: 22,
      feature: "Lead Management",
      subFeature: null,
      accessLevel: "View Only",
    },
    {
      id: 23,
      feature: "Pipeline Management",
      subFeature: "Urgent Assignment",
      accessLevel: "View Only",
    },
    {
      id: 24,
      feature: "User Management",
      subFeature: null,
      accessLevel: "View Only",
    },
    {
      id: 25,
      feature: "Role Management",
      subFeature: null,
      accessLevel: "View Only",
    },
    {
      id: 26,
      feature: "Assets Management",
      subFeature: "Assign Asset",
      accessLevel: "View Only",
    },
    {
      id: 27,
      feature: "Report Management",
      subFeature: null,
      accessLevel: "View Only",
    },
    {
      id: 28,
      feature: "Notifications",
      subFeature: null,
      accessLevel: "Full Access",
    },
    {
      id: 29,
      feature: "Support",
      subFeature: null,
      accessLevel: "Full Access",
    },
    // {
    //   "id": 30,
    //   "feature": "Settings",
    //   "subFeature": null,
    //   "accessLevel": "View Only"
    // }
  ];
  const [errors, setErrors] = useState({});

  const [formData, setFormData] = useState({
    roleName: "",
    description: "",
    featureAccess: {
      crm: false,
      hrms: false,
      reportingAnalytics: false,
      geolocationService: false,
    },
    privileges: privileges,
  });

  useEffect(() => {
    if (edit) {
      setFormData({
        roleName: roleIdData?.roleName || "",
        description: roleIdData?.description || "",
        featureAccess: {
          crm: false,
          hrms: false,
          reportingAnalytics: false,
          geolocationService: false,
        },
        privileges: roleIdData?.Privileges || privileges,
      });
    } else {
      setFormData({
        roleName: "",
        description: "",
        featureAccess: {
          crm: false,
          hrms: false,
          reportingAnalytics: false,
          geolocationService: false,
        },
        privileges: privileges,
      });
    }
  }, [edit, roleIdData]);
  console.log(formData, "form");

  const handlePrivilegeChange = (privId, level) => {
    const currentValue = formData.privileges?.[privId];

    setFormData((prev) => ({
      ...prev,
      privileges: {
        ...prev.privileges,
        [privId]: currentValue === level ? null : level,
      },
    }));
  };
  const dispatch = useDispatch();

  const validateForm = (formData) => {
    let newErrors = {};
    const lowerQuery = formData.roleName.toLowerCase();

    const duplicateRole = rolesData?.find((role) => {
      return role.roleName?.toLowerCase() === lowerQuery && role.id !== roleIdData?.id;
    });

    if (duplicateRole) {
      toast.success(<CustomToast type={"Error"} message={"Role already exists."} />, {
        position: "top-right",
        autoClose: 3000,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: false,
        draggable: false,
        progress: undefined,
        icon: false,
        closeButton: false,
      });
      return;
    }
    if (!formData.roleName) {
      newErrors.roleName = "Role Name is required";
    }
    if (!formData.description) {
      newErrors.description = "Role Description is required";
    }
    console.log(newErrors, "hammad");

    setErrors(newErrors);
    return Object.keys(newErrors)?.length === 0;
  };
  const handleSave = (formData) => {
    if (validateForm(formData)) {
      if (edit) {
        dispatch(
          updateRole(roleIdData.id, formData, loginData?.accessToken, () => {
            onHit();
            onClose();
          })
        );
      } else {
        dispatch(
          addRoles(formData, loginData?.accessToken, () => {
            onHit();
            onClose();
          })
        );
      }
    }
  };

  return (
    <div className="fixed inset-0 flex items-center justify-center z-50  w-full ">
      <div className="bg-gray-800 opacity-50 fixed inset-0" onClick={onClose}></div>
      <div className="w-full h-full flex items-center justify-center overflow-y-auto p-4">
        <div className="bg-white w-[95%] rounded-lg p-6 z-10 max-w-5xl shadow-lg relative max-h-[90vh] overflow-y-auto">
          <button className="absolute top-3 right-3 text-gray-600" onClick={onClose}>
            <FaTimes />
          </button>

          <h3 className="text-lg font-semibold text-gray-800 mb-4">{edit ? "Edit Role" : "Create New Role"}</h3>

          <div className="mb-4">
            <Input
              type="text"
              float={true}
              value={formData.roleName}
              onChange={(e) => setFormData({ ...formData, roleName: e.target.value })}
              placeholder="Role Name"
              label={"Role Name*"}
              error={errors.roleName}
            />
          </div>

          <div className="mb-4">
            <Input
              textarea
              value={formData.description}
              onChange={(e) => setFormData({ ...formData, description: e.target.value })}
              placeholder="Description"
              label={"Description*"}
              error={errors.description}
            />
          </div>

          <div className="mb-4">
            {/* <label className="block text-gray-700 text-sm font-medium mb-2">
    Privileges
  </label> */}
            <div className="overflow-x-auto shadow-md rounded-lg overflow-hidden">
              <table className="w-full">
                <thead className="bg-gray-100">
                  <tr className="text-left text-sm text-gray-700">
                    <th className="py-3 px-4 w-2/5 min-w-[350px]">Feature Access</th>
                    <th className="py-3 px-4 text-center min-w-[500px]">Access Granted</th>
                  </tr>
                </thead>
                <tbody>
                  {formData.privileges.slice(0, 7).map((priv, index) => {
                    const isDashboard = priv.feature === "Dashboard";
                    return (
                      <tr key={priv.id} className="border-t border-gray-200 text-sm">
                        <td className="py-3 px-4 text-gray-800 ">
                          {priv.feature}
                          {priv.subFeature ? ` - ${priv.subFeature}` : ""}
                        </td>
                        <td className="py-3 px-8">
                          <div className="flex items-center justify-start space-x-6">
                            {["Restricted", ...(!isDashboard ? ["View Only", "Edit"] : []), "Full Access"].map(
                              (level) => (
                                <label key={level} className="inline-flex items-center space-x-2">
                                  <input
                                    type="checkbox"
                                    className={`
                      appearance-none 
                      h-5 w-5 
                      border border-gray-400 
                      rounded-sm
                      checked:bg-primary 
                      checked:border-transparent 
                      focus:outline-none 
                      transition duration-200
                    `}
                                    name={`privilege-${priv.id}`}
                                    value={level}
                                    checked={priv.accessLevel === level}
                                    // disabled={
                                    //   level === "Restricted" &&
                                    //   priv.feature === "Dashboard"
                                    // } // Prevent unchecking
                                    onChange={() => {
                                      setFormData((prev) => {
                                        const updatedPrivileges = prev.privileges.map((priv, i) => {
                                          if (i === index) {
                                            return {
                                              ...priv,
                                              accessLevel: level,
                                            }; // Always set, no uncheck
                                          }
                                          return priv;
                                        });
                                        return {
                                          ...prev,
                                          privileges: updatedPrivileges,
                                        };
                                      });
                                    }}
                                  />

                                  <span
                                  // style={{
                                  //   color: priv.feature === "Dashboard" && level === "Restricted" ? "gray" : "black",
                                  // }}
                                  >
                                    {level}
                                  </span>
                                </label>
                              )
                            )}
                          </div>
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            </div>
          </div>

          <div className="flex justify-end mt-6 space-x-4">
            <AuthButton
              className="bg-white px-4 py-2 border border-gray-300 rounded-md hover:bg-gray-100"
              width={"20%"}
              title={"Cancel"}
              onClick={onClose}
            />

            <AuthButton
              onClick={() => handleSave(formData)}
              width={"20%"}
              title={edit ? "Edit" : "Save"}
              className="px-4 py-2  text-white rounded-md"
            />
          </div>
        </div>
      </div>
    </div>
  );
};
